
export default {
  list: {},
  edit: {
  },
  // actions: {},
};
